import React, { useContext } from "react";
import Result from "antd/lib/result";
import Button from "antd/lib/button";
import api from "../api";

const AuthContext = React.createContext();

export const useAuthContext = () => useContext(AuthContext);

export class AuthProvider extends React.PureComponent {
  onAuthenticate = (data, callback) => {
    localStorage.setItem("access_token", data.access_token);
    this.value.isAuthenticated = true;
    this.forceUpdate(callback);
  };
  value = {
    isAuthenticated: false,
    onAuthenticate: this.onAuthenticate,
  };
  state = {
    loading: true,
  };
  componentDidMount() {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      var config = {
        method: "get",
        url: "/auth/api/user/info",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
  
  api(config)
        .then((response) => {
          this.value.isAuthenticated = true;
          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          localStorage.removeItem("access_token");
          this.value.isAuthenticated = false;
          this.setState({
            loading: false,
          });
          // console.log(error);
        });
    } else {
      this.value.isAuthenticated = false;
      this.setState({
        loading: false
      });
    }
  }

  render() {
    if (this.state.loading) return <div>Loading...</div>;
    return (
      <AuthContext.Provider value={this.value}>
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

export const AuthRouteWrapper = (Comp) =>
  class AuthRouteWrapper extends React.Component {
    componentDidMount() {
      // console.log("ON MOUNT", this.context)
      if (!this.context.isAuthenticated) {
        this.props.history.replace("/app/auth/login");
      }
    }

    componentDidUpdate() {
      // console.log(this.context)
    }

    render() {
      if (this.context.isAuthenticated) {
        return <Comp {...this.props} />;
      }
      return (
        <Result
          status="403"
          title="403"
          subTitle="Sorry, you are not authorized to access this page."
          extra={
            <Button
              type="primary"
              onClick={() => this.props.history.replace("/app")}
            >
              Back Home
            </Button>
          }
        />
      );
    }

    static contextType = AuthContext;
  };
